/**
 * Custom React hook to access the Overtime context.
 * Throws an error if used outside the OvertimeProvider.
 */
import { useContext } from 'react'
import { OvertimeContext } from './OvertimeContext'
import { OvertimeContextType } from './OvertimeContextTypes'

export function useOvertime(): OvertimeContextType {
  const context = useContext(OvertimeContext)
  
  if (context === undefined) {
    throw new Error('useOvertime must be used within an OvertimeProvider')
  }
  
  return context
}
